import { Box, Button, Container, Divider, Typography } from "@mui/material";
import React from "react";
import footer2 from "../Images/icalllogo3.png";
import { Link } from "react-router-dom";

const Footer = () => {

    const commonTextStyle = {
        color: "#fff",
        fontWeight: 400,
        letterSpacing: '0.5px',
        lineHeight: 1.6,
        fontSize: "14px",
        marginBottom: "10px",
        "&:hover": {
            textDecoration: "underline",
            textDecorationColor: "rgb(64, 153, 247)",
        },
    };

    return (
        <Box sx={{ backgroundColor: "#000", padding: '50px 0' }}>
            <Container maxWidth="xl">
                <Box
                    sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: "20px",
                        marginTop: { md: "0", xs: '20px' },
                        alignItems: "center",
                    }}
                >
                    <Box sx={{ width: { md: "calc(40% - 10px)", xs: "100%" }, textAlign: { xs: "center", sm: "start" } }}>
                        <Typography
                            variant="h6"
                            sx={{
                                textTransform: "uppercase",
                                fontSize: { md: "24px", xs: '20px' },
                                color: '#fff',
                                fontWeight: 700,
                                marginBottom: "20px",
                            }}
                        >
                            How Download The App?
                        </Typography>
                        <Typography sx={{ ...commonTextStyle, marginTop: "20px" }} variant="body1">
                            Just download the app from the store. Simple, nice, and user-friendly application.
                        </Typography>
                        <Box sx={{ marginTop: { md: '20px', xs: '16px' } }}>
                            <Button
                                sx={{
                                    padding: '10px 30px',
                                    backgroundColor: 'rgb(64, 153, 247)',
                                    color: '#fff',
                                    textTransform: 'none',
                                    fontWeight: 500,
                                    transition: '1s',
                                    '&:hover': {
                                        backgroundColor: 'rgba(64, 152, 247, 0.73)',
                                    },
                                }}
                            >
                                <Link to="https://play.google.com/store/apps/details?id=cowberryapps.icallphonedialer.contactbook" style={{ color: '#fff', textDecoration: 'none' }}>
                                    Download App
                                </Link>
                            </Button>
                        </Box>
                    </Box>
                    <Box sx={{ width: { md: "calc(60% - 10px)", xs: "100%" } }}>
                        <Box sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "20px",
                            alignItems: "center",
                        }}>
                            <Box sx={{
                                width: { md: "calc(30% - 14px)", sm: "calc(50% - 10px)", xs: "100%" },
                                textAlign: { xs: "center", sm: "start" },
                            }}>
                                {[
                                    { text: "Home", to: "/" },
                                    { text: "About Us", to: "/about" },
                                    { text: "Features", to: "/features" },
                                    { text: "Privacy", to: "/Privacy" },
                                    { text: "Help", to: "/help" },
                                ].map((item, index) => (
                                    <Typography
                                        key={index}
                                        variant="body1"
                                        component={Link}
                                        to={item.to}
                                        sx={{ ...commonTextStyle, display: "block", textDecoration: 'none' }}
                                    >
                                        {item.text}
                                    </Typography>
                                ))}
                            </Box>
                            <Box component={Link} to="/features" sx={{
                                width: { md: "calc(30% - 14px)", sm: "calc(50% - 10px)", xs: "100%" },
                                textAlign: { xs: "center", sm: "start" }, textDecoration: 'none',
                            }}>
                                {[
                                    "Call Recording",
                                    "Fake Call",
                                    "Call Announcer",
                                    "Dark Mode",
                                    "Flash on Call"
                                ].map((text, index) => (
                                    <Typography
                                        key={index}
                                        variant="body1"
                                        sx={commonTextStyle}
                                    >
                                        {text}
                                    </Typography>
                                ))}
                            </Box>
                            <Box sx={{
                                width: { md: "calc(40% - 14px)", sm: "calc(50% - 10px)", xs: "100%" },
                            }}>
                                <Box sx={{
                                    width: { md: '70%', xs: '50%' },
                                    overflow: 'hidden',
                                    margin: { md: '0 auto', sm: '0px', xs: '0px auto' }
                                }}
                                >
                                    <img src={footer2} alt="footer" width="100%" />
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Box>
                <Box my={2}>
                    <Divider sx={{ borderBottomWidth: 1, borderColor: '#bdbdbd4f', my: "20px" }} />
                    <Typography
                        variant="body2"
                        sx={{ color: 'rgb(231 225 225 / 60%)', textAlign: { md: 'start', xs: 'center' } }}
                    >
                        © {new Date().getFullYear()} JDK Solution. All rights reserved.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
